// import { Tooltip } from 'bootstrap';
import Carousel from './components/Carousel';
import Accordion from './components/Accordion';
// import Select from "./components/unused/Select";
// import RangeSlider from './components/unused/RangeSlider';
// import Fullscreen from './components/unused/Fullscreen';
// import './components/unused/Debounce';
// import './components/unused/NiceSelect';

import './components/headerSearch';
import './components/expand';
import './components/layer';
import './components/mobileMenu';
import './components/footerMobile';
// import './components/languageExpander';
// import Glide from './components/glide.min';
if (!window.site) window.site = {};

// One time after page loading
window.site.initPage = function () {
  console.log(`🔵 Executing JS...`);

  function setParentElementClass(element, uniqueClass) {
    const { parentElement } = element;
    parentElement.classList.add(uniqueClass);
  }

  try {
    // new Fullscreen({ debug: true });
    document.querySelectorAll('.accordion-item').forEach((el) => {
       new Accordion(el);
    });

    /* ********************************* bootstrap modules start ******************************************** */
    // document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el) => {
    //   // new Tooltip(el);
    // });
    /* *********************************** bootstrap modules end ******************************************** */

    // DOC: https://swiperjs.com/swiper-api
    document.querySelectorAll('.swiper-container').forEach((el, index) => {
      const sliderUniqueClass = `carousel-${index}`;
      setParentElementClass(el, sliderUniqueClass);

      const showElements = {
        xxl: el.dataset.showOnXxl,
        xl: el.dataset.showOnXl,
        lg: el.dataset.showOnLg,
        md: el.dataset.showOnMd,
        sm: el.dataset.showOnSm,
      };

      const spaceBetweenSlides = el.dataset.spaceBetween;

      const isHero = el.closest('.m-carousel--hero');

      const parentCarousel = el.closest('.m-carousel');

      if (parentCarousel) {
        const xxlElements = el.getAttribute('data-show-on-xxl');
        const classMap = {
          '2': 'two-in-a-row',
          '3': 'three-in-a-row',
          '4': 'four-in-a-row'
        };

        const parentCarouselClassName = classMap[xxlElements];

        if (parentCarouselClassName) {
          parentCarousel.classList.add(parentCarouselClassName);
        }
      }



      new Carousel(el, 1, `.${sliderUniqueClass}`, {
          loop: isHero ? true : false,
          speed: 1000,
          navigation: true,
          observer: true,
          autoHeight: true,
          slidesPerGroup: 1,
          slidesPerView: 1,
          delay: 5000,
          spaceBetween: parseInt(spaceBetweenSlides || 24),
          breakpoints: {
            0: {
              slidesPerView: showElements.sm || 1,
              // slidesPerGroup: showElements.xxl || 1,
              spaceBetween: 0,
            },
            576: {
              slidesPerView: showElements.md || 1,
              // slidesPerGroup: showElements.xxl || 1,
              spaceBetween: 16,
            },
            768: {
              slidesPerView: showElements.lg || 1,
              // slidesPerGroup: showElements.xxl || 1,
            },
            982: {
              slidesPerView: showElements.xl || 1,
              // slidesPerGroup: showElements.xxl || 1,
            },
            1200: {
              slidesPerView: showElements.xxl || 1,
              // slidesPerGroup: showElements.xxl || 1,
            },
          },
        });


    });

    // new RangeSlider({ debug: true });
    // document.querySelectorAll('select').forEach(el => new Select(el, { debug: debug }));
    // if (debug) console.log("✅ Select OK");



    // Initialize Layer instances
    document.querySelectorAll('.photo-slider, .photo-layer').forEach(function(element) {
      new Layer(element);
    });

    document.querySelectorAll('.video-slider, .video-layer, .movie-slider, .movie-layer').forEach(function(element) {
      new Layer(element, {
        type: 'video',
        generateThumb: false
      });
    });

    document.querySelectorAll('.sound-slider, .sound-layer').forEach(function(element) {
      new Layer(element, {
        type: 'sound',
        generateThumb: false
      });
    });

    document.querySelectorAll('.yt-slider, .yt-layer').forEach(function(element) {
      if (!element.closest('#slider .yt-layer')) {
        new Layer(element, {
          type: 'yt',
          generateThumb: false
        });
      }
    });

    document.querySelectorAll('#slider .yt-layer').forEach(function(element) {
      new Layer(element, {
        type: 'yt',
        generateThumb: false,
        autoplay: true
      });
    });

    document.querySelectorAll('.transmission-slider, .transmission-layer').forEach(function(element) {
      new Layer(element, {
        type: 'transmission',
        generateThumb: false
      });
    });



  } catch (err) {
    console.error(err);
    console.log(`🔴🔴🔴 JS NOT executed properly. Process took: ${performance.now()}ms 🔴🔴🔴`);
    return;
  }

  console.log(`✅✅✅ JS executed. Process took: ${performance.now()}ms ✅✅✅`);
};

// Every time after creating new elements. For example: after ajax loading
window.site.initElements = () => {};

window.addEventListener('DOMContentLoaded', () => {
  window.site.initPage();
  window.site.initElements();
});

window.addEventListener('load', () => {});
